import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/authentication/authentication.service';
import { WindowService } from '../../../common/angular-shared/services/window/window.service';
import { BaseLoginService } from '../services/login/base-login.service';

/**
 * Used to block routes that are disabled when auth0 is turned on (e.g. /login)
 */
@Injectable()
export class Auth0Guard implements CanActivate {
  constructor(
    private router: Router,
    private windowService: WindowService,
    private authenticationService: AuthenticationService,
    private loginService: BaseLoginService
  ) {}

  /**
   * Returns false if Auth0 is enabled
   */
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let canActivate: boolean = true;

    if (this.isForPasswordReset(route)) {
      canActivate = true;
    } else if (this.isForEmailVerification(route) && this.loginService.isLoggedIn()) {
      this.router.navigate(['account-center']);
      canActivate = false;
    } else if (this.loginService.isLoggedIn()) {
      this.router.navigate(['home']);
      canActivate = false;
    } else {
      const auth0Enabled = await this.windowService.nativeWindow.controller.getIsAuth0Enabled();
      if (auth0Enabled) {
        await this.authenticationService.goToLogin();
        canActivate = false;
      }
    }

    return canActivate;
  }

  private isForEmailVerification(route: ActivatedRouteSnapshot): boolean {
    const message: string = route.queryParams['message'];
    return message && message.includes('email was verified');
  }

  private isForPasswordReset(route: ActivatedRouteSnapshot): boolean {
    const resetPassword: boolean = Boolean(route.queryParams['reset_password']);
    return resetPassword && resetPassword === true;
  }
}
